export default __webpack_public_path__ + "static/media/socialMaildark.44eae229.svg";